// features/counter/counterSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IUserStateObject{
  userName: string | undefined,
  email: string | undefined,
}

// Define a type for the slice state
interface UserState {
  user: IUserStateObject | null;
}

// Define the initial state using that type
const initialState: UserState = {
    user: {userName: '', email: ''},
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<IUserStateObject>) => {
      state.user = action.payload;
      console.log("UserRedux", action.payload);
    }
  }
});

export const { setUser } = userSlice.actions;

export default userSlice.reducer;
